<!-- TODO - why are we making the whole card clickable? this means that any clickable element below has to manage event propagation -->
<forge-card #card class="no-padding" [outlined]="outlined" (click)="onCardClick()" [ngClass]="cardClasses" telemetry="Submission-SearchCard">

    <div *ngIf="hasHeader" fxFlex fxLayout="row" fxLayoutAlign="space-around center" [ngClass]="cardHeaderClasses" class="tt-card-header-container">

        <div fxFlex="auto" fxLayout="column">

            <span fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between center" class="min-width-0">

                <span fxLayout="row" fxLayoutAlign="start center" [ngClass]="headerGroupClasses">

                    <card-avatar *ngIf="showAvatar" [item]="item" (click)="$event.stopPropagation()" style="padding-right: 18px;" tabindex="-1" telemetry="Submission-StopProp">
                    </card-avatar>

                    <div fxFlex="auto" fxLayout="column" fxLayoutAlign="center start" class="truncate">

                        <div fxLayout="row" class="forge-typography--heading4">

                            <div *ngFor="let field of headerElements; last as $last" fxFlex fxLayout="row" [ngClass]="getHeaderElementClasses($last)">

                                <div *ngIf="isAction(field)" (click)="performFieldCommand(field, $event)" [ngClass]="getClass(field)" class="truncate infocard-link" [attr.telemetry]="getHeaderActionAriaLabel(field)">
                                    {{getValue(field)}}
                                </div>

                                <div *ngIf="!isAction(field)" [ngClass]="getClass(field)" class="truncate" [attr.telemetry]="field.Label">
                                    {{getValue(field)}}
                                </div>

                                <div *ngIf="!$last">&nbsp; &bull; &nbsp;</div>
                            </div>
                        </div>

                        <div *ngIf="!isEmphasized && hasSubHeader" fxFlex="100" fxLayout="row">
                            <div *ngFor="let field of subHeaderElements; last as $last" fxFlex fxLayout="row" [ngClass]="getHeaderElementClasses($last)">

                                <div *ngIf="isAction(field)" (click)="performFieldCommand(field, $event)" class="truncate" [ngClass]="getClass(field)" [attr.telemetry]="getHeaderActionAriaLabel(field)">
                                    {{getValue(field)}}
                                </div>

                                <div *ngIf="!isAction(field)" [attr.telemetry]="field.Label" class="truncate" [ngClass]="getClass(field)">
                                    {{getValue(field)}}
                                </div>

                                <div *ngIf="!$last">&nbsp; &bull; &nbsp;</div>
                            </div>
                        </div>
                    </div>
                </span>

                <span *ngIf="isCompact" #compactDetail fxFlex fxLayout="row" fxLayoutAlign="end center">
                    <span *ngFor="let rows of getPrimaryFieldsForGroup()" class="primary-row" fxFlex fxLayout="row">

                        <info-card-detail-field fxFlex [itemMetadata]="item.Metadata" [rows]="rows" [maxWidth]="getPrimaryFieldWidth()" (executeCommand)="performFieldCommand($event)">
                        </info-card-detail-field>
                    </span>

                    <chip-collection fxLayout="row" fxLayoutAlign="end end" [chips]="chips" (click)="$event.stopPropagation()" class="zIndex2">
                    </chip-collection>

                    <forge-icon-button *ngFor="let cmd of iconCommands" class="compact-commands">
                        <command [command]="cmd"></command>
                    </forge-icon-button>

                    <!-- TODO - refactor to edit command -->
                    <forge-icon-button *ngIf="allowEdit" class="compact-commands" [disabled]="!allowEdit" (click)="onEdit($event)" telemetry="Submission-Edit">
                        <forge-tooltip placement="bottom">Edit</forge-tooltip>
                    <forge-icon name="edit"></forge-icon>
                        </forge-icon-button>

                    <!-- TODO - refactor to delete command -->
                    <forge-icon-button *ngIf="canDelete && allowDelete" class="compact-commands" [disabled]="!allowDelete" (click)="onDelete($event)" telemetry="Submission-Delete">
                        <forge-tooltip placement="bottom">Delete</forge-tooltip>
                    <forge-icon name="delete"></forge-icon>
                        </forge-icon-button>

                    <div fxLayout="column" fxLayoutAlign="center end">
                        <!-- TODO - if we are always hiding the Chips, then we should replace this with a command-menu because that is all this is providing now... -->
                        <note-and-attachment *ngIf="showVertMenu" [entity]="noteAttachmentEntity" [disableAttachments]="!item.AllowAttachments" [disableNotes]="!item.AllowNotes" [disabled]="!item.AllowAttachmentEdit" [hideChips]="true" [hideSubject]="item.HideNoteSubject" [additionalCommands]="additionalCommands" [chips]="chips" telemetry="Submission-ChipClick">
                        </note-and-attachment>
                    </div>
                </span>

                <span *ngIf="!isCompact" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <div class="info-card-title-field" fxFlex>{{item.TitleField}}</div>

                    <chip-collection fxLayout="row" fxLayoutAlign="end end" [chips]="chips" (click)="$event.stopPropagation()" class="zIndex2">
                    </chip-collection>

                    <div fxLayout="column" fxLayoutAlign="center end" class="info-card-aggregates">
                        <div *ngFor="let field of item.AggregateElements" fxFlex fxLayout="row" fxLayoutAlign="end center" [ngStyle]="getAggregateElementColor(field)">
                            <div *ngIf="field.Label" fxFlex="auto" fxLayoutAlign="end center">
                                {{field.Label}}:&nbsp;
                            </div>
                            <div fxFlex="auto" fxLayoutAlign="start center">{{field.Value}}</div>
                        </div>
                    </div>

                    <div fxFlex="5"></div>

                    <div fxLayout="row" fxLayoutAlign="end start">
                        <div *ngFor="let cmd of iconCommands">
                            <command [command]="cmd" (click)="$event.stopPropagation()"></command>
                        </div>
                    </div>

                    <!-- TODO - edit command -->
                    <forge-icon-button *ngIf="editable" [disabled]="!allowEdit" (click)="toggleEditMode()" telemetry="Submission-Edit">
                        <forge-tooltip placement="bottom">Edit</forge-tooltip>
                    <forge-icon name="edit"></forge-icon>
                        </forge-icon-button>

                    <!-- TODO - no Delete when not compact? -->

                    <div fxLayout="column" fxLayoutAlign="center end">
                        <!-- TODO - if we are always hiding the Chips, then we should replace this with a command-menu because that is all this is providing now... -->
                        <note-and-attachment *ngIf="showVertMenu" [entity]="noteAttachmentEntity" [additionalCommands]="additionalCommands" [disableAttachments]="!item.AllowAttachments" [disableNotes]="!item.AllowNotes" [disabled]="!item.AllowAttachmentEdit" [hideChips]="true" [hideSubject]="item.HideNoteSubject" [chips]="chips" telemetry="Submission-ChipClick">
                        </note-and-attachment>
                    </div>
                </span>
            </span>

            <ng-container *ngIf="isHeaderCustom">
                <custom-view *ngIf="isCustomView(headerComponent)" [component]="getCustomView(headerComponent)" [customDataBinding]="item">
                </custom-view>
            </ng-container>
        </div>
    </div>

    <forge-divider *ngIf="isEmphasized && hasHeader"></forge-divider>

    <!-- TODO is this hidden if `!isEmphasized` -->
    <div *ngFor="let group of item.GroupDataElements" class="tt-card-body">

        <!-- TODO - flip to showTitle -->
        <div *ngIf="!hideTitle(group.GroupName)" class="forge-typography--heading2">
            {{group.GroupName}}
        </div>

        <!-- TODO - flip boolean to showPrimaryDetail -->
        <div *ngIf="!hidePrimaryDetail(group.GroupName)" fxLayout="column" fxLayoutAlign="space-around" [ngClass]="groupDataFieldClasses" class="primary-collapsed">

            <div *ngFor="let rows of getPrimaryFieldsForGroup(group)" fxLayout="row" class="primary-row">

                <info-card-detail-field fxFlex [itemMetadata]="item.Metadata" [rows]="rows" [maxWidth]="getPrimaryFieldWidth(group)" (executeCommand)="performFieldCommand($event)">
                </info-card-detail-field>
            </div>
        </div>

        <div *ngIf="isEmphasized && hasItems(group.GroupName)" fxLayout="column" fxLayoutAlign="space-around" class="pad-top-10">

            <div *ngFor="let rows of getSecondaryFieldsForGroup(group)" class="primary-row" fxLayout="row">
                <info-card-detail-field fxFlex [itemMetadata]="item.Metadata" [rows]="rows" [maxWidth]="getSecondaryFieldWidth(group)" (executeCommand)="performFieldCommand($event)">
                </info-card-detail-field>
            </div>
        </div>
    </div>

    <!-- TODO - Too much logic in this conditional, make a property with a simple name for this state... -->
    <div *ngIf="isEmphasized && (isDetailTable || isDetailCustom)" fxLayout="column" fxLayoutAlign="space-around">

        <!-- TODO - should be ignoring the @Input cardProviderId or is there some order of precedence we should be using? -->
        <info-card-detail-table *ngIf="isDetailTable" [cardProviderId]="item.CardProviderId" [itemId]="item.Id">
        </info-card-detail-table>

        <ng-container *ngIf="isDetailCustom">
            <custom-view *ngIf="isCustomView(detailComponent)" [component]="getCustomView(detailComponent)" [customDataBinding]="item">
            </custom-view>
        </ng-container>

    </div>

    <div *ngIf="hasBarCommands" [fxShow]="isEmphasized" fxLayout="row" fxLayoutAlign="end center" class="forge-card-footer-container" style="padding: 1rem;">
        <command-bar [commands]="itemCommands" (click)="$event.stopPropagation()"></command-bar>
    </div>
</forge-card>
